import { getPersonalizationCampaigns } from "../services/personalization.service";
import { handleize } from "../helpers/utils";
class MainNavDesktop extends HTMLElement {
    config = null;
    categoryEl = null;
    constructor() {
        super();
        this.addEventListener("focusin", this.handleNavChange);
        this.addEventListener("mouseover", this.handleNavChange);
    }
    async connectedCallback() {
        console.log("MainNavDesktop : connectedCallback");
        try {
            this.config = window.UTK_themeConfig?.mainNavigationDesktop;
            if (window.UTK_themeConfig?.mainNavigationPersonalizationDesktop) {
                const selectorName = window.UTK_themeConfig?.mainNavigationPersonalizationDesktop.apiSelectorName;
                const personalizationResults = await getPersonalizationCampaigns({ apiSelectorNames: [selectorName] });
                const decision = personalizationResults.choices.find((c) => c.name.toLowerCase() === selectorName.toLowerCase());
                if (decision?.variations) {
                    const payloadData = decision.variations[0].payload.data;
                    if (payloadData) {
                        const id = payloadData.id;
                        const variation = window.UTK_themeConfig?.mainNavigationPersonalizationDesktop.variations.find((v) => v.variationId.toLowerCase() === id.toLowerCase());
                        if (variation) {
                            const behavior = variation.variationBehavior;
                            if (behavior === "replace") {
                                console.log("MainNavDesktop: replacing desktop nav config", variation.replacement);
                                this.config = variation.replacement;
                            }
                        }
                    }
                    else {
                        console.log("user served control");
                    }
                }
            }
        }
        catch (e) {
            console.error("Error parsing config", e);
        }
        finally {
            console.log("MainNavDesktop : rendered config", this.config);
            this.render();
        }
    }
    handleNavChange(e) {
        const target = e.target;
        const menuLinkOuterEl = target.classList.contains('menu-link-outer') ? target : target.closest('.menu-link-outer');
        if (menuLinkOuterEl) {
            const key = menuLinkOuterEl.getAttribute('data-key');
            const section = this.config?.sections.find(section => handleize(section.title) === key);
            this.populateCategoryEl(section?.categories, section?.title);
        }
    }
    render() {
        if (!this.config) {
            console.error(`MainNavDesktop: No config found. Sanity config: ${window.UTK_themeConfig ? 'found' : 'missing'}. Main nav config: ${window.UTK_themeConfig?.mainNavigationDesktop ? 'found' : 'missing'}.`);
        }
        else if (!this.config?.sections || this.config?.sections.length === 0) {
            console.error(`MainNavDesktop: No sections found in config.`, this.config);
        }
        const initSection = (this.config?.sections || []).find(section => {
            const found = (section.categories || []).find(s => location.href.includes(s.url));
            if (found) {
                return section;
            }
        }) || this.config?.sections[0];
        this.innerHTML = `
      <ul class="header__desktop-menu-list">
        ${this.config?.sections.map(section => {
            const handle = handleize(section.title);
            return `
            <li id="nav_${handle}" class="menu-link-outer" data-key="${handle}">
              <a class="menu-link-top" href="${section.url || "#"}" style="${section.color ? `color: ${section.color.value};text-decoration-color: ${section.color.value}` : ''}">
                <span>${section.title}</span>
              </a>
            </li>
          `;
        }).join('')}
        ${this.getNobiButton() || ''}
      </ul>
    `;
        // render subnav
        const subnavElContainer = document.createElement('div');
        subnavElContainer.classList.add('header__desktop-menu-list-sub-nav-container');
        this.categoryEl = subnavElContainer;
        this.append(subnavElContainer);
        this.populateCategoryEl(initSection?.categories, initSection?.title);
    }
    populateCategoryEl(categories, sectionTitle) {
        if (this.categoryEl) {
            if (categories?.length > 0) {
                this.categoryEl.classList.remove('hidden');
                this.categoryEl.innerHTML = `
        <ul class="header__desktop-menu-list-sub-nav" id="main-nav-desktop-subnav_${handleize(sectionTitle)}">
          ${categories.map(category => {
                    return `
              <li>
                <a id="main-nav-desktop-subnav-link_${handleize(sectionTitle)}_${handleize(category.title)}" class="header__desktop-menu-list-sub-nav-link" style="${category.color ? `color: ${category.color.value};` : ''}"  href="${category.url}">${category.title}</a>
              </li>
            `;
                }).join('')}
        </ul>
      `;
            }
            else {
                this.categoryEl.classList.add('hidden');
                this.categoryEl.innerHTML = "";
            }
        }
    }
    getNobiButton() {
        const nobiButtonTemplate = document.getElementById('nobi-button-template');
        if (!nobiButtonTemplate) {
            return null;
        }
        const fragment = nobiButtonTemplate.content.cloneNode(true);
        return `<li id="nav_search" class="menu-link-outer" data-key="search">${fragment.firstElementChild?.outerHTML}</li>`;
    }
}
if (!window.customElements.get("main-nav-desktop")) {
    customElements.define("main-nav-desktop", MainNavDesktop);
}
